const o = "{{currentTime}} de {{duration}}", n = "Resultado de la búsqueda {{current}} de {{total}}", t = "No se encontraron resultados", c = "Se encontró {{count}} resultado", e = "Se encontraron {{count}} resultados", s = 'Reproduciendo desde $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) y $t(SECONDS, { "count": {{seconds}} }).', a = 'Reproduciendo desde $t(MINUTES, { "count": {{minutes}} }) y $t(SECONDS, { "count": {{seconds}} }).', r = 'Reproduciendo desde $t(SECONDS, { "count": {{seconds}} }).', A = "Se produjo un error al guardar los cambios en la transcripción.", i = "Línea de la transcripción a las {{time}}. El contenido es: {{text}}.", E = 'Contenedor de líneas de transcripción. Hay $t(TRANSCRIPT_LINES, { "count": {{count}} }) dentro de este contenedor. Para navegar dentro de este contenedor, use la tecla de flecha que apunta hacia abajo.', d = "Guardando los cambios…", T = "Se guardaron los cambios de la transcripción.", S = "Ya está disponible el botón Actualizar subtítulos.", _ = "Acción", u = "Agregar anotación a las {{time}}", l = "Agregar preguntas a {{time}}", R = "Anotaciones", N = "Automático", I = "Automático ({{quality}})", O = "Volver", C = "Subtítulos", P = "Idioma de los subtítulos", U = "Administrar subtítulos", L = "Eliminar {{language}}", p = "Tamaño de fuente", D = "Idioma de los subtítulos: {{language}}", m = "{{language}} (automático)", M = "Borrar búsqueda", b = "Cerrar", G = "Comentarios", Y = "Seguir", g = "Bajar la velocidad de reproducción", h = "Bajar el volumen un {{percent}}%", B = "Flecha hacia abajo", V = "Cerrar el editor de transcripción", H = "Actualizar subtítulos", v = "¡Error!", F = "Guardando…", K = "¡Guardado!", q = "Editar transcripción", W = "El texto no puede quedar vacío.", $ = "Pantalla completa", f = "{{count}} hora", j = "{{count}} horas", x = "Subir la velocidad de reproducción", Q = "Subir el volumen un {{percent}}%", y = "Invertir colores", z = "Saltar a un porcentaje específico (1-10 %, 2-20 %, etc.)", J = "Saltar a comenzar", Z = "Acciones para {{title}}", X = "Métodos abreviados de teclado", k = "Idioma", w = "Flecha izquierda", oo = "Menú principal", no = "{{count}} minuto", to = "{{count}} minutos", co = "Silenciar", eo = "Silenciado", so = "Siguiente idioma de los subtítulos", ao = "Siguiente resultado de la búsqueda", ro = "Desactivado", Ao = "Sobre", io = "Abrir anotación a las {{time}}", Eo = "Abrir examen completo a las {{time}}", To = "Abrir examen a las {{time}}", So = "Pausar", _o = "Reproducir", uo = "Velocidad de reproducción", lo = "Velocidad de reproducción: {{speed}}x", Ro = "Idioma anterior de los subtítulos", No = "Anterior resultado de la búsqueda", Io = "Calidad", Oo = "Menú de calidad", Co = "Repetir", Po = "Restablecer la velocidad de reproducción", Uo = "Flecha a la derecha", Lo = "Buscar en la transcripción", po = "{{count}} segundo", Do = "{{count}} segundos", mo = "Buscar hacia atrás: {{seconds}} segundos", Mo = "Buscar hacia adelante: {{seconds}} segundos", bo = "Configuraciones", Go = "Método abreviado", Yo = "Detalles y herramientas multimedia", go = "Barra espaciadora", ho = "Menú de la velocidad de reproducción", Bo = "Iniciar desplazamiento automático", Vo = "Cambiar los subtítulos", Ho = "Alternar silencio", vo = "Alternar reproducir/pausar", Fo = "es {{count}} línea de transcripción", Ko = "son {{count}} líneas de transcripción", qo = "Cargando transcripción…", Wo = "No pudimos cargar la transcripción.", $o = "Opciones de transcripción", fo = "Reintentar", jo = "Transcripción no disponible", xo = "Flecha hacia arriba", Qo = "Configuraciones de video", yo = "Volumen", zo = "Volumen: {{volume}}%", Jo = {
  A11Y_DURATION: o,
  A11Y_SEARCH_HITS: n,
  A11Y_SEARCH_NO_RESULTS: t,
  A11Y_SEARCH_RESULTS_FOUND: c,
  A11Y_SEARCH_RESULTS_FOUND_other: e,
  A11Y_TIMESTAMP_JUMP_HOURS: s,
  A11Y_TIMESTAMP_JUMP_MINUTES: a,
  A11Y_TIMESTAMP_JUMP_SECONDS: r,
  A11Y_TRANSCRIPT_ERROR: A,
  A11Y_TRANSCRIPT_LINE: i,
  A11Y_TRANSCRIPT_LINES: E,
  A11Y_TRANSCRIPT_SAVING: d,
  A11Y_TRANSCRIPT_SUCCESS: T,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: S,
  ACTION: _,
  ADD_ANNOTATION_AT: u,
  ADD_QUESTION_AT: l,
  ANNOTATIONS: R,
  AUTO: N,
  AUTO_QUALITY: I,
  BACK: O,
  CAPTIONS: C,
  CAPTIONS_LANGUAGE: P,
  CAPTIONS_MANAGE: U,
  CAPTION_DELETE: L,
  CAPTION_FONT_SIZE: p,
  CAPTION_LANGUAGE: D,
  CAPTION_LANGUAGE_AUTOMATIC: m,
  CLEAR_SEARCH: M,
  CLOSE: b,
  COMMENTS: G,
  CONTINUE: Y,
  DECREASE_PLAYBACK_SPEED: g,
  DECREASE_VOLUME: h,
  DOWN_ARROW: B,
  EDIT_CLOSE: V,
  EDIT_CONFIRM: H,
  EDIT_ERROR: v,
  EDIT_SAVING: F,
  EDIT_SUCCESS: K,
  EDIT_TRANSCRIPT: q,
  EDIT_VALIDATION_ERROR: W,
  FULLSCREEN: $,
  HOURS: f,
  HOURS_other: j,
  INCREASE_PLAYBACK_SPEED: x,
  INCREASE_VOLUME: Q,
  INVERT_COLORS: y,
  JUMP_TO_PERCENTAGE: z,
  JUMP_TO_START: J,
  KEBAB_MENU: Z,
  KEYBOARD_SHORTCUTS: X,
  LANGUAGE: k,
  LEFT_ARROW: w,
  MAIN_MENU: oo,
  MINUTES: no,
  MINUTES_other: to,
  MUTE: co,
  MUTED: eo,
  NEXT_CAPTION_LANGUAGE: so,
  NEXT_HIT: ao,
  OFF: ro,
  ON_TOP: Ao,
  OPEN_ANNOTATION_AT: io,
  OPEN_COMPLETED_QUIZ_AT: Eo,
  OPEN_QUIZ_AT: To,
  PAUSE: So,
  PLAY: _o,
  PLAYBACK_SPEED: uo,
  PLAYBACK_SPEED_MESSAGE: lo,
  PREVIOUS_CAPTION_LANGUAGE: Ro,
  PREVIOUS_HIT: No,
  QUALITY: Io,
  QUALITY_MENU: Oo,
  REPLAY: Co,
  RESET_PLAYBACK_SPEED: Po,
  RIGHT_ARROW: Uo,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Lo,
  SECONDS: po,
  SECONDS_other: Do,
  SEEK_BACKWARD: mo,
  SEEK_FORWARD: Mo,
  SETTINGS: bo,
  SHORTCUT: Go,
  SIDEBAR: Yo,
  SPACE: go,
  SPEED_MENU: ho,
  START_AUTOSCROLL: Bo,
  TOGGLE_CAPTIONS: Vo,
  TOGGLE_MUTED: Ho,
  TOGGLE_PLAY_PAUSE: vo,
  TRANSCRIPT_LINES: Fo,
  TRANSCRIPT_LINES_other: Ko,
  TRANSCRIPT_LOADING: qo,
  TRANSCRIPT_LOAD_ERROR: Wo,
  TRANSCRIPT_OPTIONS: $o,
  TRANSCRIPT_RETRY: fo,
  TRANSCRIPT_UNAVAILABLE: jo,
  UP_ARROW: xo,
  VIDEO_SETTINGS: Qo,
  VOLUME: yo,
  VOLUME_VALUE: zo
};
export {
  o as A11Y_DURATION,
  n as A11Y_SEARCH_HITS,
  t as A11Y_SEARCH_NO_RESULTS,
  c as A11Y_SEARCH_RESULTS_FOUND,
  e as A11Y_SEARCH_RESULTS_FOUND_other,
  s as A11Y_TIMESTAMP_JUMP_HOURS,
  a as A11Y_TIMESTAMP_JUMP_MINUTES,
  r as A11Y_TIMESTAMP_JUMP_SECONDS,
  A as A11Y_TRANSCRIPT_ERROR,
  i as A11Y_TRANSCRIPT_LINE,
  E as A11Y_TRANSCRIPT_LINES,
  d as A11Y_TRANSCRIPT_SAVING,
  T as A11Y_TRANSCRIPT_SUCCESS,
  S as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  _ as ACTION,
  u as ADD_ANNOTATION_AT,
  l as ADD_QUESTION_AT,
  R as ANNOTATIONS,
  N as AUTO,
  I as AUTO_QUALITY,
  O as BACK,
  C as CAPTIONS,
  P as CAPTIONS_LANGUAGE,
  U as CAPTIONS_MANAGE,
  L as CAPTION_DELETE,
  p as CAPTION_FONT_SIZE,
  D as CAPTION_LANGUAGE,
  m as CAPTION_LANGUAGE_AUTOMATIC,
  M as CLEAR_SEARCH,
  b as CLOSE,
  G as COMMENTS,
  Y as CONTINUE,
  g as DECREASE_PLAYBACK_SPEED,
  h as DECREASE_VOLUME,
  B as DOWN_ARROW,
  V as EDIT_CLOSE,
  H as EDIT_CONFIRM,
  v as EDIT_ERROR,
  F as EDIT_SAVING,
  K as EDIT_SUCCESS,
  q as EDIT_TRANSCRIPT,
  W as EDIT_VALIDATION_ERROR,
  $ as FULLSCREEN,
  f as HOURS,
  j as HOURS_other,
  x as INCREASE_PLAYBACK_SPEED,
  Q as INCREASE_VOLUME,
  y as INVERT_COLORS,
  z as JUMP_TO_PERCENTAGE,
  J as JUMP_TO_START,
  Z as KEBAB_MENU,
  X as KEYBOARD_SHORTCUTS,
  k as LANGUAGE,
  w as LEFT_ARROW,
  oo as MAIN_MENU,
  no as MINUTES,
  to as MINUTES_other,
  co as MUTE,
  eo as MUTED,
  so as NEXT_CAPTION_LANGUAGE,
  ao as NEXT_HIT,
  ro as OFF,
  Ao as ON_TOP,
  io as OPEN_ANNOTATION_AT,
  Eo as OPEN_COMPLETED_QUIZ_AT,
  To as OPEN_QUIZ_AT,
  So as PAUSE,
  _o as PLAY,
  uo as PLAYBACK_SPEED,
  lo as PLAYBACK_SPEED_MESSAGE,
  Ro as PREVIOUS_CAPTION_LANGUAGE,
  No as PREVIOUS_HIT,
  Io as QUALITY,
  Oo as QUALITY_MENU,
  Co as REPLAY,
  Po as RESET_PLAYBACK_SPEED,
  Uo as RIGHT_ARROW,
  Lo as SEARCH_TRANSCRIPT_PLACEHOLDER,
  po as SECONDS,
  Do as SECONDS_other,
  mo as SEEK_BACKWARD,
  Mo as SEEK_FORWARD,
  bo as SETTINGS,
  Go as SHORTCUT,
  Yo as SIDEBAR,
  go as SPACE,
  ho as SPEED_MENU,
  Bo as START_AUTOSCROLL,
  Vo as TOGGLE_CAPTIONS,
  Ho as TOGGLE_MUTED,
  vo as TOGGLE_PLAY_PAUSE,
  Fo as TRANSCRIPT_LINES,
  Ko as TRANSCRIPT_LINES_other,
  qo as TRANSCRIPT_LOADING,
  Wo as TRANSCRIPT_LOAD_ERROR,
  $o as TRANSCRIPT_OPTIONS,
  fo as TRANSCRIPT_RETRY,
  jo as TRANSCRIPT_UNAVAILABLE,
  xo as UP_ARROW,
  Qo as VIDEO_SETTINGS,
  yo as VOLUME,
  zo as VOLUME_VALUE,
  Jo as default
};
